import { apiGet } from './client';
import webApi from "./WebApi.js";

export const getGlobal = (locale) =>
  apiGet(`/content/global-setting?locale=${encodeURIComponent(locale)}`);

export const getHeader = (locale) =>
  apiGet(`/content/header?locale=${encodeURIComponent(locale)}`);

export const getHomepage = (locale) =>
  apiGet(`/content/homepage?locale=${encodeURIComponent(locale)}`);

export const getEditUser = (locale) =>
  apiGet(`/content/edituser?locale=${encodeURIComponent(locale)}`);

export const getConfiguration = (locale) =>
  apiGet(`/content/configuration?locale=${encodeURIComponent(locale)}`);

export const getAdmissionPage = (locale) =>
  apiGet(`/content/admissionpage?locale=${encodeURIComponent(locale)}`);

export const getSolicitudPage = (locale) => 
  apiGet(`/content/solicitudpage?locale=${encodeURIComponent(locale)}`);

export const getAdminHombePage = (locale) => 
  apiGet(`/content/home-administration?locale=${encodeURIComponent(locale)}`);

export const getAdminApplicationPage = (locale) => 
  apiGet(`/content/request-administration?locale=${encodeURIComponent(locale)}`);

export const getAdminFilePage = (locale) => 
  apiGet(`/content/files-administration?locale=${encodeURIComponent(locale)}`);

export const getAdminSponsorPage = (locale) => 
  apiGet(`/content/sponsor-administration?locale=${encodeURIComponent(locale)}`);

export const getAdminRAdmissionPage = (locale) => 
  apiGet(`/content/admission-report-administration?locale=${encodeURIComponent(locale)}`);

export const getAdminRattendancePage = (locale) => 
  apiGet(`/content/attendance-administration?locale=${encodeURIComponent(locale)}`);

export const getAdminPendingPage = (locale) => 
  apiGet(`/content/penging-administration?locale=${encodeURIComponent(locale)}`);

export const getLoginPage = (locale) => 
  apiGet(`/content/loging-page?locale=${encodeURIComponent(locale)}`);

export const getDaminOfertPage = (locale) => 
  apiGet(`/content/programofert-administration?locale=${encodeURIComponent(locale)}`);

export const getAdminEducenterPage = (locale) => 
  apiGet(`/content/educenter-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminProfilesPage = (locale) => 
  apiGet(`/content/profiles-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminAcademicPage = (locale) => 
  apiGet(`/content/academiclevel-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminParameterPage = (locale) => 
  apiGet(`/content/profileparameter-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminTemplatePage = (locale) => 
  apiGet(`/content/templates-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminTemplateTypePage = (locale) => 
  apiGet(`/content/templatetype-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminUserPage = (locale) => 
  apiGet(`/content/users-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminWaysToKnowPage = (locale) => 
  apiGet(`/content/ways-to-know-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminPeriodPage = (locale) => 
  apiGet(`/content/period-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminPeriodTypesPage = (locale) => 
  apiGet(`/content/periodtypes-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminReasonPage = (locale) => 
  apiGet(`/content/reason-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminFinancialTypePage = (locale) => 
  apiGet(`/content/financialtype-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminOrgTypePage = (locale) => 
  apiGet(`/content/orgtype-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminPlacesPage = (locale) => 
  apiGet(`/content/places-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminDocumentTypePage = (locale) => 
  apiGet(`/content/documenttype?locale=${encodeURIComponent(locale)}`);

export const getAdminSidebarPage = (locale) => 
  apiGet(`/content/sidebar-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminNavbarPage = (locale) => 
  apiGet(`/content/navbar-admin?locale=${encodeURIComponent(locale)}`);

export const getAdminGeneralSettingPage = (locale) => 
  apiGet(`/content/generalsetting?locale=${encodeURIComponent(locale)}`);

export const getValidation = (locale) => 
  apiGet(`/content/validation?locale=${encodeURIComponent(locale)}`);

export const getVerifyPage = (locale) => 
  apiGet(`/content/verification?locale=${encodeURIComponent(locale)}`);

export const getNotificationPage = (locale) => 
  apiGet(`/content/notification?locale=${encodeURIComponent(locale)}`);

export const getApplictionDataPage = (locale) => 
  apiGet(`/content/appliction-data?locale=${encodeURIComponent(locale)}`);

export const getGestorTranslationPage = (locale) =>
  apiGet(`/content/gestor-translation?locale=${encodeURIComponent(locale)}`);

// Función para obtener traducciones de pantallas desde la API principal
export const getScreenTranslations = async () => {
  const api = webApi.api();
  const response = await api.get("Traducciones/GetScreenTraductions");
  return response.data;
};

// Función para crear una nueva traducción
export const createTranslation = async (data) => {
  const api = webApi.api();
  const response = await api.post("Traducciones/Create/Traduction/Screen", data);
  return response.data;
};

// Función para actualizar una traducción existente
export const updateTranslation = async (screen, key, traducciones) => {
  const api = webApi.api();
  const response = await api.put(`Traducciones/Update/Traduction/Screen/${screen}/${key}`, {
    traducciones: traducciones
  });
  return response.data;
};

// Función para eliminar una traducción
export const deleteTranslation = async (screen, key) => {
  const api = webApi.api();
  const response = await api.delete(`Traducciones/Delete/Traduction/Key/${screen}/${key}`);
  return response.data;
};